import { DataPrivacyAgreementsV1NaptimeResource } from './__generated__/DataPrivacyAgreementsV1';

class DataPrivacyAgreementsV1 extends DataPrivacyAgreementsV1NaptimeResource {
  static RESOURCE_NAME = 'dataPrivacyAgreements.v1' as const;
}

export default DataPrivacyAgreementsV1;
